module.exports = __webpack_public_path__ + "media/images/www/guide/stress_icon-d9ff49dc2b7834ef4c128ae84bcf53c7.svg";